import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import { useTheme } from '@mui/material';
import { Award } from 'react-feather';
import { moneyPrintWithoutZeros } from '@pv/common/utils';
import PlanChip from '../../PlanChip';
import { ValidPlans } from '../../../types';

const SummaryContainer = styled(Box)({
  padding: '16px',
  gap: '12px',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  borderRadius: '8px',
  boxShadow: '0px 0px 3px 0px rgba(0, 0, 0, 0.12)',
  bgcolor: '#f5f5f5',
});

interface BasePlanPricingSummaryBoxProps {
  selectedPlan: {
    tier: ValidPlans;
    planName: string;
    monthlyRate: number;
    billingInterval: string;
  };
  monthlyRateWithDiscount: number;
  discount: number;
}

export const BasePlanPricingSummaryBox = ({
  selectedPlan,
  monthlyRateWithDiscount,
  discount,
}: BasePlanPricingSummaryBoxProps) => {
  if (selectedPlan?.tier === 'starter') {
    return (
      <SummaryContainer>
        <RiskFreeGuarantee />
      </SummaryContainer>
    );
  }
  const monthlyRate = selectedPlan?.monthlyRate / 100.0 || 0.0;

  return (
    <SummaryContainer>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h5">
          {discount > 0 && (
            <>
              <s>
                {selectedPlan?.billingInterval === 'annual' &&
                  `${moneyPrintWithoutZeros(monthlyRate * 12)} billed annually`}
                {selectedPlan?.billingInterval === 'monthly' &&
                  `${moneyPrintWithoutZeros(monthlyRate)} billed monthly`}
              </s>
              <br />
            </>
          )}
          <span>
            {selectedPlan?.billingInterval === 'annual' &&
              `${moneyPrintWithoutZeros(
                monthlyRateWithDiscount * 12
              )} billed annually`}
            {selectedPlan?.billingInterval === 'monthly' &&
              `${moneyPrintWithoutZeros(
                monthlyRateWithDiscount
              )} billed monthly`}
            {discount > 0 && ` after ${discount * 100}% discount`}
          </span>
        </Typography>
        <PlanChip plan={selectedPlan?.tier} />
      </Box>
      <RiskFreeGuarantee />
    </SummaryContainer>
  );
};

export const RiskFreeGuarantee = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mt: 2,
      }}
    >
      <Award
        style={{
          color: theme.palette.secondary.main,
          marginRight: '4px',
        }}
      />
      <Typography variant="body2">
        Risk-free <strong>30 Day Money Back Guarantee</strong> for all plans
      </Typography>
    </Box>
  );
};
